import './grid-line-item.scss';

interface Props {
    children: React.ReactNode;
}

const GridLineItem: React.FC<Props> = ({ children }) => {
    return (
        <div className="grid-line-item">
            {children}
        </div>
    )
}

export default GridLineItem;
